import { Routes, Route } from 'react-router-dom'

import { AppProvider } from '@!/providers'
import React, { Suspense, lazy } from 'react'
const LoginPage = lazy(() => import('@!/User/Login/containers/LoginPage').then((module) => ({ default: module.LoginPage })))
const RegistrationPage = lazy(() => import('@!/User/Login/containers/RegistrationPage').then((module) => ({ default: module.RegistrationPage })))
const RegistrationCompletePage = lazy(() =>
  import('@!/User/Login/containers/RegistrationCompletePage').then((module) => ({ default: module.RegistrationCompletePage })),
)
const PasswordReset = lazy(() => import('../containers/PasswordReset').then((module) => ({ default: module.PasswordReset })))
import { useAppSettings } from '@!/Hooks/useAppSettings'

const LoginApp = (props) => {
  const jotaiStore = useAppSettings({ isSaveLastUrl: false, csrfToken: props.csrf_token, csrfParams: props.csrf_params, alertMessage: props.alert_message })

  return (
    <AppProvider jotaiStore={jotaiStore}>
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/registrations" element={<RegistrationPage />} />
          <Route path="/registration_complete" element={<RegistrationCompletePage />} />
          <Route path="/password_reset" element={<PasswordReset />} />
          <Route path="/*" element={<LoginPage />} />
        </Routes>
      </Suspense>
    </AppProvider>
  )
}

export default LoginApp
